import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Spinner } from 'react-bootstrap';
import { schedulesService } from '../../services';
import { msToHMS } from '../../helpers';

const LoadShiftDetails = ({ teamMemberId, date }) => {
  const [shiftDetails, setShiftDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getShiftDetails = () => {
    const shiftParams = {
      teamMemberId,
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      fromDate: `${date} 00:00:01`,
      toDate: `${date} 23:59:59`,
    };
    setIsLoading(true);
    schedulesService
      .get_shifts_details(shiftParams)
      .then((response) => {
        if (response.message === 'Success') {
          const shiftData = response.data;
          setIsLoading(false);
          setShiftDetails(shiftData);
        } else {
          setIsLoading(false);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const loginStatus = (flag, ShiftTime, WsTime, param = null) => {
    const time1 = moment(ShiftTime);
    const time2 = moment(WsTime);
    if (flag === 'checkin') {
      if (time1.isSame(time2)) {
        return 'No Variance';
      }
      if (time1.isBefore(time2)) {
        const diffInMinutes = time2.diff(time1, 'minutes');
        if (diffInMinutes <= param.lateThreshold) {
          return 'No Variance';
        }
        const duration = moment.duration(time2.diff(time1));
        return `${`Late login by ${msToHMS(duration)}`}`;
      }
      if (time1.isAfter(time2)) {
        const differenceInMinutes = time1.diff(time2, 'minutes');

        if (differenceInMinutes <= param.lateThreshold) {
          return 'No Variance';
        }
        const duration = moment.duration(time1.diff(time2));
        return `Early login by ${msToHMS(duration)}`;
      }
    }

    if (flag === 'checkout') {
      if (time1.isSame(time2)) {
        return 'No Variance';
      }
      if (time2.isBefore(time1)) {
        const chkDiffInMinutes = time1.diff(time2, 'minutes');
        if (chkDiffInMinutes <= param.lateThreshold) {
          return 'No Variance';
        }
        const duration = moment.duration(time1.diff(time2));
        return `${`Early logout by ${msToHMS(duration)}`}`;
      }
      if (time2.isAfter(time1)) {
        const chkDiffInMin = time2.diff(time1, 'minutes');
        if (chkDiffInMin <= param.lateThreshold) {
          return 'No Variance';
        }
        const duration = moment.duration(time2.diff(time1));
        return `${`Late logout by ${msToHMS(duration)}`}`;
      }
    }
    return 'N/A';
  };

  useEffect(() => {
    getShiftDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {shiftDetails ? (
        <ul className="m-0 p-0 list-unstyled">
          <li>
            <small>
              <strong>Shift:</strong>
              {shiftDetails.shiftStart && shiftDetails.shiftStart != null ? (
                <span className="text-muted">
                  {' '}
                  {moment(shiftDetails.shiftStart).format('hh:mm A')} to{' '}
                  {moment(shiftDetails.shiftEnd).format('hh:mm A')}
                </span>
              ) : (
                <span className="text-muted"> No shift details</span>
              )}
            </small>
          </li>
          <li>
            <small>
              <strong>Check-in:</strong>
              <span className="text-muted">
                {' '}
                {moment(shiftDetails.checkInDate).format('LT')}
              </span>
            </small>
          </li>
          <li>
            <small>
              <strong>Variance:</strong>{' '}
              <span className="text-muted">
                {shiftDetails.shiftStart
                  ? loginStatus(
                      'checkin',
                      shiftDetails.shiftStart,
                      shiftDetails.checkInDate,
                      shiftDetails
                    )
                  : 'No shift details'}
              </span>
            </small>
          </li>
          <li>
            <small>
              <strong>Check-Out:</strong>
              {shiftDetails.checkOutDate !== null ? (
                <span className="text-muted">
                  {' '}
                  {moment(shiftDetails.checkOutDate).format('LT')}
                </span>
              ) : (
                <span className="text-muted"> Not checked out</span>
              )}
            </small>
          </li>

          <li>
            <small>
              <strong>Variance:</strong>{' '}
              <span className="text-muted">
                {' '}
                {shiftDetails.shiftEnd
                  ? loginStatus(
                      'checkout',
                      shiftDetails.shiftEnd,
                      shiftDetails.checkOutDate,
                      shiftDetails
                    )
                  : 'No shift details'}
              </span>
            </small>
          </li>
        </ul>
      ) : (
        <>
          {!isLoading && (
            <span className="text-muted"> No shift details available</span>
          )}
        </>
      )}
      {isLoading && (
        <section className="d-flex align-items-center justify-content-center">
          <Spinner animation="border" size="sm" />
        </section>
      )}
    </>
  );
};

LoadShiftDetails.propTypes = {
  teamMemberId: PropTypes.string,
  date: PropTypes.string,
};

export default LoadShiftDetails;
